export const HYDRATION_STANDARD_SCROLL_BUFFER = 750;
export const HYDRATION_STANDARD_DELAY_TIMER = 1500;

// BrowseAndSearch
export const SERVER_SIDE_PRODUCT_POD_COUNT = 12;
export const CLIENT_SIDE_PRODUCT_POD_COUNT = 24;
export const MAX_PODS_TO_HYDRATE = 12;
